import React from "react";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "consts/env";

const libraries = ["places"];

export default function Mapa(props) {
    const { lat, lng, width } = props;
    const center = {
        lat: lat
            ? typeof lat === "number"
                ? lat
                : parseFloat(lat)
            : -34.6036844,
        lng: lng
            ? typeof lng === "number"
                ? lng
                : parseFloat(lng)
            : -58.3815591,
    };
    const containerStyle = {
        flexGrow: 1,
        height: "300px",
        maxWidth: width || "70%",
        margin: "1rem 0",
    };

    return (
        <LoadScript
            id="google-map-script"
            googleMapsApiKey={`${GOOGLE_MAP_KEY}`}
            libraries={libraries}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={14}
            >
                <Marker position={center} />
            </GoogleMap>
        </LoadScript>
    );
}
